import React from 'react';
import { IIconProps, IconHeight, IconSizes, IconWidth } from './type';

const Add: React.FC<IIconProps> = ({
  size = IconSizes.md,
  UNSAFE_className,
  color = 'black',
  ...props
}) => {
  return (
    <svg
      width={IconWidth[size]}
      height={IconHeight[size]}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={UNSAFE_className || ''}
      {...props}
    >
      <path
        d="M3 5.92857C3 5.33684 3.33579 4.85714 3.75 4.85714H28.25C28.6642 4.85714 29 5.33684 29 5.92857C29 6.5203 28.6642 7 28.25 7H3.75C3.33579 7 3 6.5203 3 5.92857Z"
        fill={color}
      />
      <path
        d="M3 16C3 15.4083 3.33579 14.9286 3.75 14.9286H28.25C28.6642 14.9286 29 15.4083 29 16C29 16.5917 28.6642 17.0714 28.25 17.0714H3.75C3.33579 17.0714 3 16.5917 3 16Z"
        fill={color}
      />
      <path
        d="M3.75 25C3.33579 25 3 25.4797 3 26.0714C3 26.6632 3.33579 27.1429 3.75 27.1429H28.25C28.6642 27.1429 29 26.6632 29 26.0714C29 25.4797 28.6642 25 28.25 25H3.75Z"
        fill={color}
      />
      <path
        d="M23.4286 5.78571C23.4286 7.32422 22.1814 8.57143 20.6429 8.57143C19.1043 8.57143 17.8571 7.32422 17.8571 5.78571C17.8571 4.24721 19.1043 3 20.6429 3C22.1814 3 23.4286 4.24721 23.4286 5.78571Z"
        fill={color}
      />
      <path
        d="M14.1429 16C14.1429 17.5385 12.8956 18.7857 11.3571 18.7857C9.81863 18.7857 8.57143 17.5385 8.57143 16C8.57143 14.4615 9.81863 13.2143 11.3571 13.2143C12.8956 13.2143 14.1429 14.4615 14.1429 16Z"
        fill={color}
      />
      <path
        d="M19.7143 26.2143C19.7143 27.7528 18.4671 29 16.9286 29C15.3901 29 14.1429 27.7528 14.1429 26.2143C14.1429 24.6758 15.3901 23.4286 16.9286 23.4286C18.4671 23.4286 19.7143 24.6758 19.7143 26.2143Z"
        fill={color}
      />
    </svg>
  );
};

export default Add;
